import Icon from '../components/Icon.vue'

Icon.register({"share-alt-square":{"width":448,"height":512,"paths":[{"d":"M448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM304 296C289.4 296 276.2 301.6 266.2 310.7L198.3 269.9A56.3-56.3 0 0 1 198.3 242.1L266.2 201.3C276.2 210.4 289.4 216 304 216 334.9 216 360 190.9 360 160S334.9 104 304 104 248 129.1 248 160C248 164.8 248.6 169.5 249.7 173.9L181.8 214.7C171.8 205.6 158.6 200 144 200 113.1 200 88 225.1 88 256S113.1 312 144 312C158.6 312 171.8 306.4 181.8 297.3L249.7 338.1A56.1-56.1 0 0 1 248 352C248 382.9 273.1 408 304 408S360 382.9 360 352C360 321.1 334.9 296 304 296z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/share-alt-square.js
// module id = null
// module chunks = 